module.exports = "https://static-production.npmjs.com/668aac888e52ae13cac9cfd71fabd31f.xml";